import {
  FC,
  PropsWithChildren,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import { observer } from 'mobx-react-lite';
import { Content, ContentWrapper, Trigger, Wrapper } from './details.styled';
import { Icons } from 'assets';
import { SVG } from '../../svg';

interface IDetailsProps {
  title: ReactNode;
  isOpen?: boolean;
  onToggle?: (isOpen: boolean) => void;
}

export const Details: FC<PropsWithChildren<IDetailsProps>> = observer(
  ({ title, isOpen, onToggle, children }) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [isLocalOpen, setIsLocalOpen] = useState<boolean>(!!isOpen);
    const [contentHeight, setContentHeight] = useState<number>(0);

    useEffect(() => {
      if (isOpen !== undefined) {
        setIsLocalOpen(isOpen);
      }
    }, [isOpen]);

    // Обновляем высоту при изменении контента
    useEffect(() => {
      const observer = new ResizeObserver(() => {
        if (contentRef.current) {
          setContentHeight(contentRef.current.scrollHeight);
        }
      });

      if (contentRef.current) {
        observer.observe(contentRef.current);
      }

      return () => {
        observer.disconnect();
      };
    }, [children]);

    const toggleOpen = () => {
      setIsLocalOpen((prev) => {
        const newState = !prev;
        onToggle?.(newState);

        return newState;
      });
    };

    return (
      <Wrapper isOpen={isLocalOpen}>
        <Trigger onClick={toggleOpen}>
          {title}{' '}
          <SVG
            src={Icons.Chevron}
            props={{ cursor: 'inherit', isMirror: isLocalOpen }}
          />
        </Trigger>

        <ContentWrapper
          style={{
            height: isLocalOpen ? `${contentHeight}px` : '0px',
            opacity: isLocalOpen ? '1' : '0',
          }}
        >
          <Content ref={contentRef}>{children}</Content>
        </ContentWrapper>
      </Wrapper>
    );
  }
);
